import { EntityAudit } from "@modernary/mui/components/audit";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { RouterView } from "vue-router";
import { EntityNotes } from "@modernary/mui/components/note";

// Troubleshoot your routes using this - https://paths.esm.dev

/** @type {import('vue-router').RouterOptions['routes']} */

const names = {
  complaints: "Complaint.Complaints",
  list: "Complaint.ComplaintList",
  new: "Complaint.ComplaintNew",
  base: "Complaint.ComplaintBase",
  view: "Complaint.ComplaintView",
  edit: "Complaint.ComplaintEdit",
  created: "Complaint.ComplaintCreated",
  processComplaint: "Complaint.ProcessComplaint",
  notApplicable: "Complaint.NotApplicable",
  noInvestigation: "Complaint.NoInvestigation",
  addToInvestigation: "Complaint.AddToInvestigation",
  complaintInvestigationsChildList: "Complaint.ComplaintInvestigationsChildList",
  documents: "Complaint.ComplaintDocuments",
  documentsEdit: "Complaint.ComplaintDocumentsEdit",
  documentsNew: "Complaint.ComplaintDocumentsNew",
  notes: "Complaint.ComplaintNotes",
  noteEdit: "Complaint.ComplaintNoteEdit",
  noteNew: "Complaint.ComplaintNoteNew",
  audit: "Complaint.ComplaintAudit",
};

export { names as complaintRouteNames };

const complaintRoutes = [
  {
    path: "/complaint",
    name: names.complaints,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Complaints", lookupGroups: ["State", "ProgramType", "ComplaintType", "ComplaintStatus"] },
        component: () => import("@/views/complaint/ComplaintList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/complaint/ComplaintBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Complaint", isNew: true },
            component: () => import("@/views/complaint/ComplaintEdit.vue"),
          },
        ],
      },
      {
        path: "created",
        name: names.created,
        meta: { title: "Complaint Created", isForm: true },
        component: () => import("@/views/complaint/ExternalComplaintCreated.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/complaint/ComplaintBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Complaint View" },
            component: () => import("@/views/complaint/ComplaintView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Complaint Edit", isForm: true },
            component: () => import("@/views/complaint/ComplaintEdit.vue"),
          },
          {
            path: "investigations",
            name: names.complaintInvestigationsChildList,
            meta: { title: "Complaint Investigations" },
            component: () => import("@/views/complaint/InvestigationChildList.vue"),
          },
          {
            path: "process",
            name: names.processComplaint,
            meta: { title: "Process Complaint", isForm: true },
            component: () => import("@/views/complaint/ProcessComplaint.vue"),
          },
          {
            path: "notApplicable",
            name: names.notApplicable,
            meta: { title: "Not Applicable", isForm: true },
            component: () => import("@/views/complaint/NotApplicable.vue"),
          },
          {
            path: "noInvestigation",
            name: names.noInvestigation,
            meta: { title: "No Investigation", isForm: true },
            component: () => import("@/views/complaint/NoInvestigation.vue"),
          },
          {
            path: "addToInvestigation",
            name: names.addToInvestigation,
            meta: {
              title: "Add To Investigation",
              isForm: true,
              lookupGroups: ["InspectionType", "InspectionStatus", "ProgramType"],
            },
            component: () => import("@/views/complaint/AddToInvestigation.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Complaint Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="complaint" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Complaint Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="complaint" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Complaint Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="complaint" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Complaint Notes" },
            component: {
              render: () => <EntityNotes idField="complaintId" routeNamePrefix="Complaint.ComplaintNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Complaint Note", isForm: true },
            component: () => import("@/views/complaint/ComplaintNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Complaint Note", isForm: true },
            component: () => import("@/views/complaint/ComplaintNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Complaint Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Complaint" />,
            },
          },
        ],
      },
    ],
  },
];
export default complaintRoutes;
